
export const setDateTimeAsUTC = (dateTime) => {

    if (dateTime.indexOf('T') > -1 && dateTime.indexOf('+') === -1) {
        return dateTime + 'Z';
    }

    return dateTime;
}
